<div *ngIf="expired" class="content-main-blocked">
    <img src="assets/blocked.svg" class="page-blocked-image" alt="imagem_link_expirado">
    <div class="message-text">
        <h3 style="text-align: center;">OPA!</h3>
        <br>
        <div style="text-align: center;">Provavelmente o link foi expirado!</div>
    </div>
</div>

<div *ngIf="completed" class="content-main-blocked">
    <img src="assets/completed.svg" class="page-blocked-image" alt="imagem_completed">
    <div class="message-text">
        <h3 style="text-align: center;">PROCESSO FINALIZADO!</h3>
        <br>
        <div style="text-align: center;">Em breve recebera o e-mail com a cópia dos documentos.</div>
    </div>
</div>

<div *ngIf="canceled" class="content-main-blocked">
    <img src="assets/canceled.svg" class="page-blocked-image" alt="imagem_canceled">
    <div class="message-text">
        <h3 style="text-align: center;">PROCESSO CANCELADO!</h3>
        <br>
        <div style="text-align: center;">Em breve recebera o e-mail com o informativo de cancelamento.</div>
    </div>
</div>


